import { render, staticRenderFns } from "./passo3.vue?vue&type=template&id=fab45244&scoped=true&"
import script from "./passo3.vue?vue&type=script&lang=js&"
export * from "./passo3.vue?vue&type=script&lang=js&"
import style0 from "./passo3.vue?vue&type=style&index=0&id=fab45244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab45244",
  null
  
)

export default component.exports